import type { ReactNode } from "react"
import cx from "clsx"
import styles from "./Layout.module.scss"
import Logo from "@rawa/ui/assets/logo.svg?react"

// `fill` bounds the page to the viewport height (instead of the default
// min-height, which grows/scrolls with content). A page opts in when it wants a
// child to scroll within the viewport rather than grow the page — e.g. the
// location list. Other pages leave it off and keep growing/body-scrolling.
export function Layout({
  children,
  fill = false,
}: {
  children: ReactNode
  fill?: boolean
}) {
  return (
    <div className={cx(styles.page, { [styles.pageFill]: fill })}>
      <header className={styles.header}>
        <Logo
          role="img"
          className={styles.logo}
          aria-label="Relationships Australia WA"
        />
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  )
}
